import { Field } from "typegraph";

import { ID } from "common/entities/IEntity";


export default class Badge {

	@Field()
	public id: ID;

	@Field()
	public title: string;

	@Field()
	public imageUrl: string;

	@Field()
	public pending: boolean;

	@Field()
	public issuedAt?: string;

	@Field()
	public expiresAt?: string;

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/Badge.ts